import { ReportPage } from '@/pages/inspection/report/ReportPage';
import { createFileRoute } from '@tanstack/react-router';

function InspectionReportRoute() {
	const { inspectionId } = Route.useParams();
	return <ReportPage inspectionId={inspectionId} />;
}

export const Route = createFileRoute('/_authenticated/_app/inspection/inspections/$inspectionId/')({
	component: InspectionReportRoute,
});
